import React, { useEffect, useRef } from 'react';
import PageLayout from '../components/templates/PageLayout';
import LinkButton from '../components/atoms/LinkButton';

const NotFound = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    document.title = 'Page not found | DataRook';
    headingRef.current?.focus();
  }, []);

  return (
    <PageLayout>
      <div className="dr-container py-16 text-center">
        <h1
          ref={headingRef}
          tabIndex={-1}
          className="text-3xl md:text-4xl mb-4 focus:outline-none"
        >
          We can&apos;t find that page
        </h1>
        <p className="mb-8 max-w-prose mx-auto text-navy">
          That link doesn&apos;t match a DataRook page. Try Home, footyLab, or Contact.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <LinkButton to="/">Home</LinkButton>
          <LinkButton to="/footylab">footyLab</LinkButton>
          <LinkButton to="/contact" variant="primary">
            Contact
          </LinkButton>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFound;
